export const $ = (id) => document.getElementById(id);
